import { render, staticRenderFns } from "./TestsDetails.vue?vue&type=template&id=42b106ac"
import script from "./TestsDetails.vue?vue&type=script&lang=js"
export * from "./TestsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports